export interface IEmailConfig {
  email: string
  emailProvider: string
  isTenantConfigured: boolean
  isConfigured: boolean
  configVersion: InboxConfigVersion
  isAuthenticated: boolean
  syncDate?: Date
  hasReadWriteScope: boolean
}

export enum ConfigProcessingEnum {
  init = 'init',
  confirm = 'confirm',
  delete = 'delete',
  sync = 'sync',
}

export enum EmailProviderEnum {
  office = 'Office365',
  gmail = 'Gmail',
}

export enum InboxConfigVersion {
  old = 'Hf',
  new = 'Azure',
}
